const AddSubscriptionLineResponseTypeDefine = {
  PARAMETERS_UNDEFINED: "PARAMETERS_UNDEFINED",
  SAME_PRODUCT: "SAME_PRODUCT",
  API_ERROR: "API_ERROR",
  NONE_SUBSCRIPTION: "NONE_SUBSCRIPTION",
  SUCCESS: "SUCCESS",
  LOADING: "LOADING",
} as const;
type AddSubscriptionLineResponseType =
  typeof AddSubscriptionLineResponseTypeDefine[keyof typeof AddSubscriptionLineResponseTypeDefine];

type AddSubscriptionLineApiType = {
  status: AddSubscriptionLineResponseType;
};

export type { AddSubscriptionLineApiType, AddSubscriptionLineResponseType };

export { AddSubscriptionLineResponseTypeDefine };
